import React from 'react'
import { BrowserRouter as Router, Switch, Route, Link, withRouter } from "react-router-dom"
import { Layout, Breadcrumb } from 'antd'
import MainNav from '../src/components/MainNav'
import Highlight from '../src/components/Highlight'
import Resources from '../src/components/Resources'
import Tools from '../src/components/Tools'
import Copyright from './components/Copyright'
import MainContent from './components/MainContent'
import StorageUtils from './utils/StorageUtils'
import MemoryUtils from './utils/MemoryUtils'

import 'antd/dist/antd.css'
import './App.css'

import breadcrumbNameMapConf from './config/breadcrumbNameMap'

const { Header, Footer, Content } = Layout


class App extends React.Component {
  state = {
    isLogin: false,
    pathSnippets: []
  }

  // 将该方法传入其他需要关联用户登录状态的组件
  setUserState = (status) => {
    this.setState({isLogin: status})
  }

  parseBreadcrumbItems = () => {
    const { pathSnippets } = this.state
    const breadcrumbNameMap = breadcrumbNameMapConf
    let extraBreadcrumbItems, url
    
    extraBreadcrumbItems = pathSnippets.map((val, index) => {
      url = `/${pathSnippets.slice(0, index + 1).join('/')}`
      if (breadcrumbNameMap[url]) {
        return (
          <Breadcrumb.Item key={url}>
            <Link to={url}>{breadcrumbNameMap[url]}</Link>
          </Breadcrumb.Item>
        )
      } else {
        // 只支持两级路径或菜单的面包屑导航生成
        if (index < 2) {
          return (
            <Breadcrumb.Item key={url}>
              {val}
            </Breadcrumb.Item>
          )
        }
      }
    })
    
    const breadcrumbItems = [
      <Breadcrumb.Item key="home">
        <Link to="/">Home</Link>
      </Breadcrumb.Item>,
    ].concat(extraBreadcrumbItems)

    return breadcrumbItems
  }
  // 将该方法传入其他需要更新面包屑导航的组件
  setPathSnippetsState = (_pathSnippets) => {
    this.setState({ pathSnippets: _pathSnippets })
  }

  componentDidMount() {
    const user = StorageUtils.getUser()
    MemoryUtils.user = user
    const pathSnippets = this.props.location.pathname.split('/').filter(i => i)
    let isLogin
    if (user) {
      isLogin = true
    }
    this.setState({ 
      isLogin: isLogin,
      pathSnippets: pathSnippets,
    })
  }

  render() {
    // 动态解析面包屑导航
    const breadcrumbItems = this.parseBreadcrumbItems()

    return (
      <Layout>
        <Header>
          <MainNav isLogin={this.state.isLogin} />
        </Header>
        <Layout>
            <Switch>
              <Route exact path="/">
                <Highlight  />
              </Route>
            </Switch>
        </Layout>
        <Layout className="main-content-layout">
          <Switch>
            <Route exact path="/">
              <Content>
                <Resources />
                <Tools />
              </Content>
            </Route>
            <Route path="/">
              <Content>
                <Breadcrumb>{breadcrumbItems}</Breadcrumb>
                <MainContent className="main-content" setUserState={this.setUserState} setPathSnippetsState={this.setPathSnippetsState} />
              </Content>
            </Route>
          </Switch>
        </Layout>
        <Footer>
          <Copyright />
        </Footer>
      </Layout>
    )
  }
}

export default withRouter(App);
